var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWarning(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 92 92",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M88,87H4c-1.4,0-2.7-0.8-3.5-2c-0.7-1.2-0.7-2.7,0-4l42-74c0.7-1.3,2-2,3.5-2s2.8,0.8,3.5,2l42,74     c0.7,1.2,0.7,2.8,0,4C90.7,86.2,89.4,87,88,87z     M10.9,79h70.3L46,17.1L10.9,79z     M50,55.1V36.5c0-2.2-1.8-4-4-4s-4,1.8-4,4v18.6     c0,2.2,1.8,4,4,4S50,57.3,50,55.1z     M49.5,71.7c0.9-0.9,1.5-2.2,1.5-3.5s-0.5-2.6-1.5-3.5     c-0.9-0.9-2.2-1.5-3.5-1.5s-2.6,0.5-3.5,1.5     s-1.5,2.2-1.5,3.5s0.5,2.6,1.5,3.5     s2.2,1.5,3.5,1.5S48.6,72.6,49.5,71.7z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.aade0e3cf354f09f8fe37d84c8dd5755.svg";
export { ForwardRef as ReactComponent };